import { useContext } from 'react';
import { AppContext } from '../../../bootstrap/App';
import CustomUserData from '../models/CustomUserData';
import { UserRegionalFormat } from '../enums/UserRegionalFormat';
import { UserRole } from '../enums/UserRole';
import { UserTheme } from '../enums/UserTheme';
import { MasterEventsView } from '../../masterEvents/models/MasterEvent';

/**
 * Get the username of the current signed-in user
 */
function useGetCurrentUser(): CustomUserData {
  const { user } = useContext(AppContext);

  const userId = user?.id;
  const data = user ? (user as unknown as Partial<CustomUserData>) : undefined;

  return {
    _id: userId ?? '',
    name: data?.name ?? '',
    createdAt: data?.createdAt ?? new Date(),
    updatedAt: data?.updatedAt,
    theme: data?.theme ?? UserTheme.Light,
    regionalFormat: data?.regionalFormat ?? UserRegionalFormat.ENGLISH_US,
    roles: data?.roles ?? [UserRole.COLLABORATOR],
    alertShown: data?.alertShown ?? [],
    bookingCalendar: data?.bookingCalendar ?? undefined,
    welcomeWizardCompleted: data?.welcomeWizardCompleted ?? false,
    masterEventsView: data?.masterEventsView ?? MasterEventsView.Table,
  };
}

export default useGetCurrentUser;
